import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import MainTitle from '@/components/title/MainTitle.vue';
import { Options, Vue } from 'vue-class-component';
import UsersTable from '@/components/users/UsersTable.vue';
import store from '@/store';
import AddUser from "@/views/user/AddUser.vue";
import CenterTop from "@/components/layout/CenterTop.vue";
var ListUserSPE = /*#__PURE__*/function (_Vue) {
  function ListUserSPE() {
    var _this;
    _classCallCheck(this, ListUserSPE);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ListUserSPE, [].concat(args));
    _defineProperty(_this, "toggleUserCreationDialog", false);
    return _this;
  }
  _inherits(ListUserSPE, _Vue);
  return _createClass(ListUserSPE, [{
    key: "isAddUser",
    get: function get() {
      return store.getters.isAddUserAvailable;
    }
  }]);
}(Vue);
ListUserSPE = __decorate([Options({
  components: {
    UsersTable: UsersTable,
    CenterTop: CenterTop,
    MainTitle: MainTitle,
    AddUser: AddUser
  }
})], ListUserSPE);
export default ListUserSPE;